// extracted by mini-css-extract-plugin
module.exports = {"head":"headerGame_head__1aKNx","h1":"headerGame_h1__310e8","nameTH":"headerGame_nameTH__VjoaF","nameEng":"headerGame_nameEng__3xB5v"};